import { useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import useSearchResultsAnalytics from '@/analytics/useSearchResultsAnalytics';

import srpActiveInteractionDuck from '@/ducks/srp/srpActiveInteractionDuck.js';
import srpPaginationDuck from '@/ducks/srp/srpPaginationDuck.js';

const AnalyticsWrapper = () => {
    const dispatch = useDispatch();

    const pagination = useSelector(srpPaginationDuck.selectors.getDuckState);
    const listingCount = useRef(false); // TODO refactor this garbage too

    useSearchResultsAnalytics({
        listingCount: listingCount.current,
        currentPage: pagination.currentPage,
        totalNumberListingsImpressionsCallback: () => {
            listingCount.current = true;
        },
        regularInventoryImpressionsCallback: () => {
            // reset active owner on page change
            dispatch(srpActiveInteractionDuck.creators.setKeys({
                ownerId: '',
            }));
        },
    });
};

export default AnalyticsWrapper;
